import {EventAggregator, Subscription} from "aurelia-event-aggregator";
import {autoinject} from "aurelia-framework";
import {map} from "lodash";

@autoinject()
export class GroupEventBus {

  constructor(private __eventAggregator: EventAggregator) {
  }

  subscribe(event, callback, subscriber?: any) {
    return this.__eventAggregator.subscribe(event, msg => {
      if (!subscriber || subscriber !== msg.sender) {
        callback(msg);
      }
    });
  }

  subscribeGroup(events, callback, subscriber) {
    return new GroupSubscription(map(events, event => {
      return this.subscribe(event, callback, subscriber);
    }));
  }

  publish(event) {
    this.__eventAggregator.publish(event);
  }

}

export class GroupSubscription {

  constructor(public subscriptions: Subscription[]) {
    this.subscriptions = subscriptions;
  }

  dispose() {
    this.subscriptions.forEach(s => s.dispose());
  }

}
